import {connect} from "react-redux"
import {ColourwayData} from "../../models/searchApi"
import State from "../../models/state"
import {getToolTipTitleByType} from "../../utils/colourwayBuilders"
import getTitleUtil from "../../utils/getTitleUtil"

export const mapStateToProps = (state: State) => {
    const {
        template,
        productSummary: {
            summaryData: {id, title, colourways, fit, department, type},
            enabledSearchDesc,
            enableSingleLineTitle,
            useProductAggregator,
        },
        request: {isEnglishLang},
    } = state

    const selectedColourway = (colourways as ColourwayData[]).find(colourway => colourway.s) as ColourwayData
    const getTitle = (
        useProductAggregator
            ? selectedColourway?.t
            : getTitleUtil({
                  enabledSearchDesc,
                  title,
                  selectedColourway,
                  fit,
                  department,
                  isEnglishLang,
                  type,
              })
    ) as string

    return {
        templating: template,
        id,
        enableSingleLineTitle,
        title: getTitle,
        tooltipTitle: getToolTipTitleByType(type, {
            title,
            defaultTitle: getTitle,
            colourwayItemNumber: selectedColourway.id,
            price: selectedColourway.p,
            salePrice: selectedColourway.sp,
            fit,
            selectedColourway,
            isEnglishLang,
        }),
    }
}

export default connect(mapStateToProps)
